<template>
  <div class="row">
    <div class="col-sm-12 col-xl-12">
      <v-card flat rounded="lg" class="performance-summary-card">
      <v-data-table
        :headers="grid.headers"
        :items="platformRows"
        :items-per-page="10"
        item-value="platform_id"
        class="table text-start align-middle mb-0 custom-data-table"
      >
        <!-- Profit Count -->
        <template v-slot:[`item.profit_stock_count`]="{ item }">
          <span class="text-success fw-bold">
            {{ item.profit_stock_count }}
          </span>
        </template>

        <!-- Loss Count -->
        <template v-slot:[`item.loss_stock_count`]="{ item }">
          <span class="text-error fw-bold">
            {{ item.loss_stock_count }}
          </span>
        </template>

        <!-- Free Stock Count -->
        <template v-slot:[`item.free_stock_count`]="{ item }">
          <span class="text-primary fw-bold">
            {{ item.free_stock_count }}
          </span>
        </template>

        <!-- Total Stock Count -->
        <template v-slot:[`item.total_stock_count`]="{ item }">
          <strong>{{ item.total_stock_count }}</strong>
        </template>
      </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
// import { fetchWrapper } from '@/helpers';

export default {
  name: 'platform-performance',

  data() {
    return {
      platformRows: [],

      grid: {
        headers: [
          { title: 'Platform', key: 'platform_name' },
          { title: 'Total Stocks', key: 'total_stock_count' },
          { title: 'Profit Stocks', key: 'profit_stock_count' },
          { title: 'Loss Stocks', key: 'loss_stock_count' },
          { title: 'Free Stocks', key: 'free_stock_count' }
        ]
      }
    }
  },

  methods: {
    getData() {
      // 🔹 SAMPLE DATA (for UI preview)
      this.platformRows = [
        {
          platform_id: 1,
          platform_name: 'Zerodha',
          total_stock_count: 20,
          profit_stock_count: 12,
          loss_stock_count: 5,
          free_stock_count: 6
        },
        {
          platform_id: 2,
          platform_name: 'Angel One',
          total_stock_count: 15,
          profit_stock_count: 8,
          loss_stock_count: 3,
          free_stock_count: 4
        },
        {
          platform_id: 3,
          platform_name: 'Groww',
          total_stock_count: 13,
          profit_stock_count: 6,
          loss_stock_count: 7,
          free_stock_count: 2
        },
        {
          platform_id: 4,
          platform_name: 'Upstox',
          total_stock_count: 14,
          profit_stock_count: 10,
          loss_stock_count: 2,
          free_stock_count: 5
        }
      ];

      // 🔹 REAL API (enable later)
      /*
      fetchWrapper.post('api/platform/summary')
        .then((response) => {
          this.platformRows = response.data;
        });
      */
    }
  },

  mounted() {
    this.getData();
  }
}
</script>

<style scoped>
.performance-summary-card {
  border: 1px solid var(--border);
}

.custom-data-table :deep(thead th) {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border) !important;
}

.custom-data-table :deep(tbody td) {
  border-bottom: 1px solid #f1f2f4 !important;
}

.custom-data-table :deep(tbody tr:hover) {
  background-color: #f8f9fb;
}
</style>